export const AssessmentEnum = {
  A5_ASSESSMENT_TYPE: "A5_AND_PHQ",
  A5_SUB_ASSESSMENT_TYPE: "A5",
  A5_V2_ASSESSMENT_TYPE: "A5_V2_AND_PHQ",
  A5R_ASSESSMENT_TYPE: "A5-R",
  DEFAULT_ASSESSMENT_TYPE: "DEFAULT",
  SNS_E: "SNS_E",
} as const;

export const AssessmentQuestionTypeEnum = {
  MULTIPLE_CHOICE: "multiple_choice",
  RANGE_CHOICE: "range_choice",
  SINGLE_CHOICE: "single_choice",
} as const;

export const AssessmentDefinitionIdEnum = {
  ACP_SATISFACTION_SURVEY: "acp_satisfaction_survey",
  SNS_E: "snse",
} as const;
